module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.9882/images/red-laughing-glasses/red-laughing-glasses@3x.png"